<template>
	<v-expansion-panels v-model="panel" flat accordion>
		<ExpansionPanel :title="'Basics'">
			<SettingSwitch
				:title="'Label'"
				:placeholder="'Type your title here'"
				:switchValue.sync="titleEnabled"
				:textFieldValue.sync="titleValue"
			/>
			<div class="display-flex flex-row width-100 align-center mb-1 flex-justify-space-between">
				<SettingSwitch :title="'Prefill'" :switchValue.sync="prefillEnabled" />
			</div>
			<div class="align-center mb-4 prefill-row display-flex flex-row width-100" v-if="prefillEnabled">
				<div class="width-100">
					<CombinedInputFieldDataMenu
						:textAreaMode="false"
						:value.sync="prefillValue"
						:attachTo="'.prefill-row'"
						:valuesTypes="dataInputMenuValueTypes"
					/>
				</div>
			</div>
			<SettingSwitch :title="'Required'" :switchValue.sync="requiredEnabled" />
		</ExpansionPanel>
		<ExpansionPanel :title="'Explanations'">
			<SettingSwitch
				:title="'Description'"
				:placeholder="'Type your description here'"
				:switchValue.sync="descriptionEnabled"
				:textFieldValue.sync="descriptionValue"
			/>
			<SettingSwitch
				:title="'Placeholder'"
				:placeholder="'Type placeholder text'"
				:switchValue.sync="placeholderEnabled"
				:textFieldValue.sync="placeholderValue"
			/>
		</ExpansionPanel>

		<ExpansionPanel :title="'Validation'">
			<v-row no-gutters class="align-center" v-for="option in fieldOptions[0].items" :key="option.key">
				<v-col v-if="option.optional">
					<v-checkbox
						dense
						color="primary"
						:inputValue="localField.metadata.validations[option.key].enabled"
						@change="(v) => updateValidationEnabled(option.key, v)"
					>
						<template v-slot:label>
							<h3 class="light" style="line-height: 16px">{{ option.name }}</h3>
						</template>
					</v-checkbox>
				</v-col>
				<v-col cols="auto" class="text-right" v-if="option.needsValue">
					<v-text-field
						style="width: 90px"
						hide-details
						:value="localField.metadata.validations[option.key].value"
						@input="(v) => updateValidationValue(option.key, v)"
						outlined
						class="ac"
						height="40"
						:placeholder="option.placeholder"
					></v-text-field>
				</v-col>
			</v-row>
		</ExpansionPanel>
	</v-expansion-panels>
</template>
<script>
import SettingSwitch from './WidgetSettings/SettingSwitch';
import ExpansionPanel from './WidgetSettings/ExpansionPanel';
import ItemOnlyAllowedValueTypesMixin from './ValueTypesMixins/ItemOnlyAllowedValueTypesMixin';
import FieldSettingsMixin from '@/components/BlockEditorWidget/FieldSettings/FieldSettingsMixin';

export default {
	name: 'EmailInputFieldSettings',
	mixins: [FieldSettingsMixin, ItemOnlyAllowedValueTypesMixin],
	components: {
		SettingSwitch,
		ExpansionPanel,
	},
	computed: {
		fieldOptions() {
			//demo data
			return [
				{
					id: 1,
					name: 'Data validation',
					items: [
						{
							key: 'email',
							name: 'Validate email',
							optional: true,
							needsValue: false,
						},
						{
							key: 'host',
							name: 'Validate email is from a specific domain',
							optional: true,
							needsValue: true,
						},
						{
							key: 'format',
							name: 'Advance: Validate email by regex',
							optional: true,
							needsValue: true,
						},
					],
				},
			];
		},
	},
};
</script>
<style scoped lang="scss">
.field-text {
	font-size: 14px;
	font-weight: normal;
	color: var(--primery-font-color);
}
.field-identifier {
	min-width: 277px;
}
</style>
